"use client";

import React, { useEffect, useState } from "react";
import { Award, Truck, Smile } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  id: 1,
  label: "累计掌握单词",
  value: 2500,
  suffix: "+",
  icon: Award
}, {
  id: 2,
  label: "连续达标天数",
  value: 120,
  suffix: "+",
  icon: Truck
}, {
  id: 3,
  label: "听力理解提升",
  value: 98,
  suffix: "%",
  icon: Smile
}];
const Counter = ({
  end,
  duration = 2000,
  isVisible
}: {
  end: number;
  duration?: number;
  isVisible: boolean;
}) => {
  const [count, setCount] = useState(0);
  useEffect(() => {
    if (!isVisible) return;
    let startTime: number | null = null;
    const step = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = Math.min((timestamp - startTime) / duration, 1);
      setCount(Math.floor(progress * end));
      if (progress < 1) {
        window.requestAnimationFrame(step);
      }
    };
    window.requestAnimationFrame(step);
  }, [end, duration, isVisible]);
  return <span>{count}</span>;
};
export default function KeyStatistics() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="48588" id="科学记忆算法" ref={ref} className="relative w-full py-16 overflow-hidden dark bg-background text-foreground">
      {}
      <div className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -top-20 -left-20 h-96 w-96 -rotate-12 bg-primary/10 blur-3xl" />
        <div className="absolute top-1/2 right-0 h-64 w-64 rotate-45 bg-secondary/10 blur-2xl" />
        
        {}
        <div className="absolute top-0 right-1/4 h-full w-[1px] bg-gradient-to-b from-transparent via-primary/20 to-transparent -skew-x-12" />
        <div className="absolute top-0 right-[22%] h-full w-[1px] bg-gradient-to-b from-transparent via-secondary/20 to-transparent -skew-x-12" />
      </div>

      <div className="container relative mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
          {stats.map((stat, i) => <div key={stat.id} data-index={i} className={`flex flex-col items-center justify-center text-center transition-all duration-700 ease-out ${isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              {}
              <div className="mb-4 relative">
                <div className="absolute inset-0 bg-primary/30 rounded-full blur-lg scale-125 opacity-50" />
                <div className="relative flex h-20 w-20 items-center justify-center rounded-2xl bg-card shadow-lg ring-2 ring-primary/20 transition-transform hover:scale-105">
                  <stat.icon className="h-10 w-10 text-primary" strokeWidth={2} />
                </div>
              </div>

              {}
              <div className="mb-2 font-sans text-5xl font-extrabold text-primary tracking-tight md:text-7xl">
                <Counter end={stat.value} isVisible={isVisible} />
                <span className="text-secondary ml-1">{stat.suffix}</span>
              </div>

              {}
              <h3 className="text-xl font-bold text-foreground/90 tracking-wide">
                {stat.label}
              </h3>
            </div>)}
        </div>
      </div>
    </section>;
}